<template>
<div class="app">
    <v-card color="grey lighten-4" flat>
        <v-layout row wrap>
            <v-flex xs12 sm12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title> Teklif Değerlendirme </v-toolbar-title>
                </v-toolbar>
            </v-flex>
        </v-layout>
    </v-card>
    <v-card color="grey lighten-5" flat>
        <v-flex pa-3xs12 sm12 md12>
            <v-layout row wrap>

                <v-flex xs12 sm7 md12>
                    <v-card flat style="min-height:450px">
                        <v-layout row wrap>
                            <v-flex pa-1 xs12 sm5 md6>
                                <v-carousel @click.native="gorseldetay=true" cycle height="450" hide-delimiter-background show-arrows-on-hover>
                                    <v-carousel-item v-for="(item,i) in istekBilgileri.ImageUrl" :key="i" :src="item.Url">
                                    </v-carousel-item>
                                </v-carousel>
                            </v-flex>
                            <v-flex pa-1 xs12 sm12 md6>
                                <v-layout row wrap>
                                    <v-flex xs12 pb-2 sm12 md12>
                                        <v-layout row wrap class=" project overdue">
                                            <v-toolbar flat="" size="120px" dark color="white">
                                                <v-toolbar-title>
                                                    <span class="title black--text font-weight-">
                                                        {{istekBilgileri.Name}} {{istekBilgileri.LastName}} -
                                                        {{istekBilgileri.BirthDate | dateformat}}
                                                    </span>
                                                </v-toolbar-title>
                                                <v-spacer></v-spacer>
                                               
                                            </v-toolbar>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex pl-4 xs12 sm12 md4>
                                        <v-select :disabled="tip" v-model="RequestUpdate.RequestType" color="grey darken-1" :label="FiyatTip">
                                        </v-select>
                                    </v-flex>
                                    <v-flex pl-4 xs12 sm12 md4>
                                        <v-select label="Kur Seçiniz:" v-model="RequestUpdate.RequestCurrency" :disabled="tip" :items="kurtipiitems" color="grey darken-1" item-text="text" item-value="value"></v-select>
                                    </v-flex>
                                    <v-flex pl-4 xs12 sm12 md4>
                                        <parainput :simge="''" :etiket="'Tutar Giriniz'" :aktif="true" v-model="RequestUpdate.RequestPrice" :autocomplete="'autocomplete'">
                                        </parainput>
                                    </v-flex>
                                    <v-flex pl-4 xs12 sm12 md12>
                                        <v-textarea :disabled="tip" label="Teşhis Açıklama" v-model="RequestUpdate.StatusMessage">
                                        </v-textarea>
                                    </v-flex>
                                    <v-flex pl-4 v-if="Status == 1  && istekBilgileri.RequestType != 2" xs12 sm12 md6 pr-4>
                                        <v-btn block color="red" @click="IstekUpdate(3)">
                                            <v-icon color="white" left>cancel
                                            </v-icon><span class="white--text"> Teklifi Reddet </span>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex pl-4 v-if="Status == 1 && istekBilgileri.RequestType != 2" xs12 sm12 md6 pr-4>
                                        <v-btn block color="green" @click="IstekUpdate(2)">
                                            <v-icon color="white" left>send
                                            </v-icon><span class="white--text"> Teklifi Onayla </span>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex pl-4 v-if="Status == 2  && istekBilgileri.RequestType != 2 && istekBilgileri.AvailabilityStatus != 1" xs12 sm12 md12 pr-4>
                                        <v-btn block color="green" @click="idgonder()">
                                            <v-icon color="white" right>insert_invitation
                                            </v-icon><span class="white--text"> Tarih Ayarla </span>
                                        </v-btn>
                                    </v-flex>

                                    <v-flex v-if="istekBilgileri.AvailabilityStatus == 1">
                                        <v-flex pl-4 xs12 sm12 md4>
                                            <span class="subheading"> Doktor Adı: </span>
                                            <p class="body-2 font-weight-light">{{musaitlikBilgileri.DoctorName}} </p>
                                        </v-flex>
                                        <v-flex pl-4 xs12 sm12 md4>
                                            <span class="subheading">İşlem Tarihi : </span>
                                            <p class="body-2 font-weight-light">{{musaitlikBilgileri.AvailabilityDate | dateformat}}</p>
                                        </v-flex>
                                    </v-flex>

                                </v-layout>

                            </v-flex>
                        </v-layout>

                        <v-layout row wrap>
                            <v-flex pa-3 xs12 sm5 md12>
                                <v-layout row wrap>
                                    <v-flex xs12 pt-2 pb-2 sm12 md12>
                                        <v-layout row wrap class=" project overdue">
                                            <v-toolbar flat="" size="120px" dark color="white">
                                                <v-toolbar-title>
                                                    <span class="title black--text font-weight-">
                                                        Hasta Detay Bilgileri
                                                    </span>
                                                </v-toolbar-title>
                                                <v-spacer></v-spacer>
                                                <!-- <v-btn color="green" @click="Rezgonder()">Rezervasyon Yap
                                                </v-btn> -->
                                            </v-toolbar>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm12 md6>
                                        <v-layout row wrap>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Sürekli kullandığınız bir ilaç var mı?
                                                        </span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.AlwaysMedicine}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Bu zamana
                                                            kadar saç dökülmesi için tedavi aldınız mı? </span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.GetTherapy}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Saçınızın en
                                                            çok döküldüğü bölümden 1 tutam saçı dibinden hafifçe tutarak
                                                            yukarıya doğru çekin. Kaç adet saç teli geldi?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.HairLossCount}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Son 6 ay
                                                            içinde 5 kilo veya daha fazlasını verdiniz mi?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.LoosFiveKg}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Son 6 ay
                                                            içinde büyük bir cerrahi operasyon geçirdiniz mi?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.SurgicalOperation}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Banyo veya
                                                            duş sırasında saçlarınızın çok döküldüğüne şahit olur
                                                            musunuz?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.ShowerHairLoss}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Saçlarınızın
                                                            sürekli döküldüğünü düşünüyor musunuz?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.AlwaysHairLoss}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Ketojenik
                                                            diyet, dukan diyeti gibi sıkı diyetler yapıyor musunuz?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.Diet}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Kafa
                                                            derinizde yanma, kaşıntı, kızarıklık var mı?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.HairBurning}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Son 6 ay
                                                            içinde tam kan sayımı veya check-up yaptırdınız mı?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.CheckUp}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Tiroid
                                                            rahatsızlığınız var mı?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.Tiroid}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Saç
                                                            tellerinizin kalınlığı nasıldır?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.HairThickness}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm12 md6>
                                        <v-layout row wrap>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Menstrual
                                                            döngünüzde bir sorun var mı? Son 6 ay içinde doğum yaptınız
                                                            mı? </span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.Menstrual}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Eklemek
                                                            istenilen not</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.RequestNote}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Saç
                                                            dökülmeniz lokal bir bölgede mi tüm kafa derisinde yaygın mı
                                                            görülmektedir?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.LocalOrGeneral}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Saç
                                                            dökülmeniz ne zamandır devam ediyor ?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.HairLossTime}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            B12
                                                            Eksikliği tanısı ile ilaç kullanıyor musunuz?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.VitaminLoss}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Kemoterapi
                                                            gördünüz mü?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.Chemotherapy}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Diyabetiniz
                                                            var mı?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.Diabetes}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Hiç demir
                                                            eksikliği tanısı ile ilaç kullandınız mı?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.IronLoss}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Ailenizde
                                                            saç dökülmesi sorunu var mı?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.FamilyHairLoss}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Vejeteryan
                                                            mısınız?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.Vegetarian}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 pb-1 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">live_help</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        <span class="subheading">
                                                            Doğal saç
                                                            renginiz nedir?</span>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 md1>
                                                        <v-icon color="grey">remove</v-icon>
                                                    </v-flex>
                                                    <v-flex xs12 sm11 md11>
                                                        {{istekBilgileri.HairColor}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                        </v-layout>
                                    </v-flex>
                                </v-layout>

                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>

    </v-card>

    <v-dialog v-model="gorseldetay" v-if="gorseldetay" scrollable="" persistent="" max-height="900px" max-width="900px">
        <v-card>
            <v-card-title>Hasta Fotoğraf Detayı</v-card-title>
            <v-divider></v-divider>
            <v-card-text>

                <v-layout row wrap="">

                    <v-flex xs12 sm12 md12>
                        <v-card flat class="white--text">
                            <v-card flat="">
                                <v-card-actions>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm12 md12>
                                            <v-carousel height="450" hide-delimiter-background show-arrows-on-hover>
                                                <v-carousel-item v-for="(item,i) in istekBilgileri.ImageUrl" :key="i" :src="item.Url">
                                                </v-carousel-item>
                                            </v-carousel>
                                        </v-flex>
                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>

                </v-layout>

            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="gorseldetay=false">{{$t('Close')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import auth from "@/api/auth.js"
import helpers from "@/components/app/customcomp/helpers.js"
import tarihcomp from "@/components/app/customcomp/tarihim.vue"
import parainput from '@/components/app/customcomp/parainput.vue'

export default {
    data() {
        return {
            istekBilgileri: {},
            musaitlikBilgileri: {},
            tip: true,
            Status: null,
            gorseldetay: false,
            FiyatTip: null,
            RequestUpdate: {
                RequestID: null,
                Status: null,
                RequestType: null,
                RequestPrice: null,
                StatusMessage: null,
                RequestCurrency: null
            },
            kurtipiitems: [{
                text: 'TRY',
                value: 'TRY'
            }, {
                text: 'EUR',
                value: 'EUR'
            }, {
                text: 'USD',
                value: 'USD'
            }],
        }
    },
    components: {
        tarihcomp,
        parainput

    },
    beforeMount: beforeMount,
    methods: {
        idgonder() {
            var url = '#/coper/clinista/acentetakvim/id?' + '&ID=' + this.$route.query.RequestID

            window.open(url, '_self')
        },
        onChange(event) {
            if (event == 0) {
                this.RequestUpdate.RequestPrice = "1250"
                this.RequestUpdate.RequestCurrency = "TRY"
            } else if (event == 1) {
                this.fiyattip = false
                this.RequestUpdate.RequestPrice = ""

            } else if (event == 2) {
                this.fiyattip = true
                this.RequestUpdate.RequestPrice = ""
                this.RequestUpdate.RequestCurrency = ""

            }
        },
        IstekUpdate: IstekUpdate

    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
    }
}

function beforeMount() {

    this.Status = this.$route.query.Status
    var params = {
        RequestID: this.$route.query.RequestID
    }

    this.$http.post(auth.CLINISTA_API_URL + 'api/Clinista/RequestLoad', params, {
        headers: {
            'Authorization': 'Basic ' + window.btoa(auth.HOTELRUNNERUSERNAME + ':' + auth
                .HOTELRUNNERUSERPASS)
        }
    }).then((response) => {
        this.istekBilgileri = response.body

        this.RequestUpdate.RequestPrice = this.istekBilgileri.RequestPrice
        this.RequestUpdate.RequestCurrency = this.istekBilgileri.RequestCurrency
        this.RequestUpdate.StatusMessage = this.istekBilgileri.StatusNote
        if (response.body.RequestType == 0) {
            if (response.body.RequestPrice == 1250) {
                this.FiyatTip = 'Standart Fiyat'
            } else {
                this.FiyatTip = this.$t('Price-Type-v2')
            }
        } else if (response.body.RequestType == 1) {
            this.FiyatTip = 'Özel Fiyat'
        } else if (response.body.RequestType == 2) {
            this.FiyatTip = 'Saç Tutmaz'
        }
        if (response.body.AvailabilityStatus == 1) {

            var paramsmusait = {
                AvailabilityID: response.body.AvailabilityID
            }

            this.$http.post(auth.CLINISTA_API_URL + 'api/Doctor/AvailabilityLoad', paramsmusait, {
                headers: {
                    'Authorization': 'Basic ' + window.btoa(auth.HOTELRUNNERUSERNAME + ':' + auth
                        .HOTELRUNNERUSERPASS)
                }
            }).then((response) => {
                this.musaitlikBilgileri = response.body

            }, (response) => {
                this.text1 = "Hatalı Kayıt."
                this.snackbar = true
            })

        }
    }, (response) => {
        this.text1 = "Hatalı Kayıt."
        this.snackbar = true
    })

}

function IstekUpdate(val) {

    this.RequestUpdate.RequestType = this.istekBilgileri.RequestType
    this.RequestUpdate.RequestPrice = this.istekBilgileri.RequestPrice
    this.RequestUpdate.RequestCurrency = this.istekBilgileri.RequestCurrency
    this.RequestUpdate.StatusMessage = this.istekBilgileri.StatusNote
    this.RequestUpdate.Status = val
    this.RequestUpdate.RequestID = this.$route.query.RequestID

    var params = this.RequestUpdate
    this.$http.post(auth.CLINISTA_API_URL + 'api/Clinista/RequestUpdate', params, {
        headers: {
            'Authorization': 'Basic ' + window.btoa(auth.HOTELRUNNERUSERNAME + ':' + auth
                .HOTELRUNNERUSERPASS)
        }
    }).then((response) => {
        this.istekBilgileri = response.body

        if (response.body.Status == true) {
            var url = '#/coper/clinista/acenteisteklistesi';

            window.open(url, '_self')
        }
        if (response.body.Status == false) {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
        }
    }, (response) => {
        this.text1 = "Hatalı Kayıt."
        this.snackbar = true
    })
}

</script>
